{
  "dss": {
    "button": {
      "back": "חזרה",
      "cancel": "ביטול",
      "close": "סגור",
      "confirmDelete": "כן, מחק",
      "continue": "המשך",
      "logout": "התנתקות",
      "passwordReset": "איפוס סיסמה",
      "save": "שמור",
      "verify": "אשר"
    },
    "error": {
      "403": "אין לך גישה לעמוד זה.",
      "404": "העמוד המבוקש לא נמצא.",
      "generic": "אירעה שגיאה. נסה שוב מאוחר יותר.",
      "throttling": "יותר מדי ניסיונות. הפעולה נחסמה לזמן מה.",
      "title": "שגיאה",
      "title403": "הגישה נדחתה",
      "title404": "העמוד לא נמצא"
    },
    "footer": {
      "imprint": "חותם",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "מדיניות פרטיות",
      "terms": "תנאי שימוש"
    },
    "label": {
      "CRMAccountNumber": "מספר חשבון CRM",
      "contact": "יצירת קשר",
      "email": "אימייל",
      "faq": "שאלות נפוצות",
      "female": "גב׳",
      "firstname": "שם פרטי",
      "help": "עזרה",
      "language": "שפה",
      "lastname": "שם משפחה",
      "male": "מר",
      "needHelp": "צריך עזרה?",
      "newPassword": "סיסמה חדשה",
      "newPassword2": "אישור סיסמה חדשה",
      "oldPassword": "סיסמה נוכחית",
      "organization": "ארגון",
      "password": "סיסמה",
      "required": "שדה חובה",
      "salutation": "פניה",
      "select": "נא לבחור"
    },
    "lang": {
      "de": "גרמנית"
    },
    "link": {
      "contact": "https://support.stihl.com/he-IL/websso-contact/",
      "faq": "https://support.stihl.com/he-IL/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "אישור הרשמה",
        "wait": "אנא המתן לסיום אישור החשבון."
      },
      "otp": {
        "btnResend": "שלח שוב קוד אימות במייל",
        "msg": {
          "invalidOTP": "הסיסמה החד-פעמית שהוזנה אינה תקינה.",
          "resendFail": "שליחה חוזרת של הקוד נכשלה. נסה שוב מאוחר יותר."
        },
        "spamDetail": "בדוק את תיבת הדואר והספאם להודעה מ-STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "לא קיבלת אימייל?",
        "subtitle": "כדי להמשיך, עליך לאמת את כתובת האימייל שלך.",
        "title": "אמת את חשבון המשתמש שלך",
        "txtVerifyMail": "הזן את קוד האימות החדש ששלחנו לכתובת האימייל שלך {email}"
      },
      "personal": {
        "msg": {
          "noChange": "אין מה לעדכן.",
          "updateError": "עדכון הנתונים האישיים נכשל.",
          "updated": "הנתונים האישיים עודכנו.",
          "userLoadErr": "שגיאה בטעינת נתוני המשתמש. נסה שוב מאוחר יותר."
        },
        "secOrganization": "ארגון",
        "secPersonal": "פרטי",
        "secSettings": "הגדרות מועדפות",
        "title": "מידע אישי"
      },
      "postPwSet": {
        "info": "כעת ניתן להשתמש בסיסמה החדשה שלך.",
        "link_name": "המשך לשירות עצמי",
        "link_url": "/user/ui/",
        "title": "הסיסמה שלך שונתה"
      },
      "resetPW": {
        "title": "אפס את הסיסמה שלך"
      },
      "security": {
        "2fa": {
          "availableMethods": "שיטות 2FA זמינות:",
          "info": "אימות דו-שלבי (2FA) מוסיף שכבת הגנה נוספת לחשבונך. יש להשתמש בשתי שיטות כדי להתחבר, ולא רק בשם משתמש וסיסמה.",
          "method": {
            "email": "אימייל",
            "emailDesc": "קבל קודים חד-פעמיים במייל להשלמת בקשות אימות.",
            "oath": {
              "add": {
                "button": "רשום אפליקציית מאמת"
              }
            }
          }
        },
        "authenticator": "אפליקציית מאמת",
        "infoFederatedAccount": "חשבון זה מנוהל על ידי ספק הזהות של הארגון שלך, ולכן לא ניתן לשנות את הסיסמה כאן. כדי לשנות את הסיסמה שלך, היכנס דרך דף הכניסה של הארגון שלך או פנה למנהל ה-IT שלך.",
        "lastUse": "שימוש אחרון ב-{0}.",
        "msg": {
          "invalidPassword": "הסיסמה הנוכחית שגויה.",
          "passwordAlreadyUsed": "לא ניתן להשתמש שוב ב-5 הסיסמאות האחרונות.",
          "pwUpdateError": "אירעה שגיאה בעת ניסיון לשנות סיסמה.",
          "pwUpdated": "הסיסמה שונתה."
        },
        "noDevice": "לא הוגדר",
        "oathAdd": {
          "appInfo": "כדי להקל על תהליך ההתחברות ל-STIHL, ניתן להשתמש באפליקציות מאמת כגון {0}, {1}, {2} וכו׳ ליצירת סיסמאות חד-פעמיות המשמשות כגורם שני בעת ההתחברות.<br/>אם איבדת או שכחת את המכשיר הנייד, תמיד ניתן להשתמש בקוד 2FA שנשלח במייל.<br/><br/>אנא עקוב אחר ההוראות שלהלן כדי להגדיר את מכשיר האימות שלך.",
          "badCode": "קוד לא תקין, נסה שוב.",
          "error": "אירעה שגיאה בעת ניסיון לרשום את מכשיר האימות.",
          "headScan": "1. סרוק את קוד ה-QR באמצעות אפליקציית המאמת",
          "headVerify": "2. אמת את הקוד",
          "infoKey": "מפתח הגדרה",
          "infoKeyTitle": "הסוד הדו-שלבי שלך",
          "infoScanBottom": "לא ניתן לסרוק? ניתן להשתמש ב-{0} כדי להגדיר ידנית את אפליקציית המאמת.",
          "infoVerify": "הזן את הקוד שנוצר על ידי אפליקציית המאמת שלך.",
          "success": "מכשיר האימות נרשם. כעת ניתן להשתמש בו להתחברות.",
          "title": "רשום את מכשיר האימות הדו-שלבי שלך"
        },
        "oathDelete": {
          "error": "אירעה שגיאה בעת ניסיון למחוק את מכשיר האימות.",
          "success": "מכשיר האימות נמחק."
        },
        "passkeys": {
          "about": {
            "info1": "Passkeys הם זוגות של מפתחות קריפטוגרפיים (מפתח ציבורי ומפתח פרטי) הנשמרים על ידי מאמת שנמצא בשליטתך. המאמת יכול להוכיח שמשתמש נוכח ומורשה להשתמש במפתח. אימות מתבצע באמצעות PIN, קוד, ביומטריה או סיסמת מכשיר, בהתאם ליכולות ולהגדרות של המאמת.",
            "info2": "בעת כניסה ל-STIHL באמצעות Passkey, המאמת שלך משתמש בקריפטוגרפיה של מפתח ציבורי כדי להוכיח את זהותך ללא שליחת המפתח עצמו. Passkeys קשורים לדומיין אתר כמו stihl-sso.com ודורשים חיבור מאובטח, כך שהדפדפן יסרב לאמת באתר מתחזה. תכונות אלו הופכות את ה-Passkeys לעמידים במיוחד בפני פישינג וקשים יותר לתקיפה מאשר SMS או TOTP 2FA.",
            "info3": "שירותי Passkey מבוססי ענן מאפשרים סנכרון של Passkeys בין מכשירים, כך שניתן להשתמש בהם ממקומות רבים יותר ופחות לאבדם. לאחר שהגדרת Passkey מסונכרן במכשיר אחד, הוא זמין לשימוש במספר מכשירים המשתמשים באותו שירות.",
            "title": "על Passkeys"
          },
          "add": {
            "button": "הוסף Passkey חדש",
            "error": "אירעה שגיאה בעת ניסיון להוסיף Passkey חדש.",
            "success": "נוסף Passkey חדש."
          },
          "delete": {
            "button": "מחק Passkey",
            "error": "אירעה שגיאה בעת ניסיון למחוק Passkey זה.",
            "success": "ה-Passkey נמחק."
          },
          "edit": {
            "error": "אירעה שגיאה בעת שמירת שם ה-Passkey.",
            "name": "שם Passkey",
            "success": "שם ה-Passkey עודכן.",
            "title": "תן ל-Passkey שלך שם כדי להבחין בו מאחרים"
          },
          "info": "Passkey הוא חלופה פשוטה ובטוחה לסיסמאות, המאמת את זהותך באמצעות מגע, זיהוי פנים, סיסמת מכשיר או PIN.",
          "none": "לא הוגדר Passkey.",
          "reallyDelete": "האם אתה בטוח שברצונך למחוק את ה-Passkey?",
          "registeredPasskeys": "ה-Passkeys הרשומים שלך:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "האם אתה בטוח שברצונך למחוק את מכשיר האימות?",
        "secMFA": "אימות דו-שלבי",
        "secPwdChange": "שנה סיסמה",
        "title": "אבטחה"
      },
      "setPW": {
        "acceptTC": "אנא אשר את ה-{terms} וקרא את ה-{privacy} שלנו.",
        "killSSO": "בטל את כל ההפעלות הפעילות",
        "msg": {
          "tokenExpired": "קישור או קוד הסיסמה פג תוקף. עקוב אחר הקישור כדי לאפס את הסיסמה: {link}."
        },
        "privacy": "מדיניות הגנת נתונים",
        "terms": "תנאים והגבלות",
        "title": "הזן סיסמה חדשה"
      }
    },
    "validations": {
      "hasDigit": "חייב להכיל ספרות",
      "hasLowercase": "חייב להכיל אותיות קטנות",
      "hasSpecial": "חייב להכיל תווים מיוחדים: {chars}",
      "hasUppercase": "חייב להכיל אותיות גדולות",
      "invalidCharacters": "מכיל תווים לא תקינים",
      "maxLength": "מותר עד {max} תווים",
      "minLength": "נדרשים לפחות {min} תווים",
      "notSameAsEmail": "דומה מדי לכתובת האימייל",
      "onlyValidCharactersAllowed": "מותר להשתמש רק באותיות, מספרים ורווחים.",
      "required": "שדה חובה",
      "sameAsPassword": "הסיסמאות אינן תואמות",
      "tcAccepted": "אנא אשר את התנאים וההגבלות שלנו.",
      "validEmail": "כתובת אימייל שגויה.",
      "validOTP": "אנא הזן את קוד האימות."
    }
  }
}
